import cn from 'clsx';
import useHexCardColor from "../../hooks/useHexCardColor";
import AchievementLogoRiveAnimation from "../AchievementLogoRiveAnimation";
import BadgeDiamond from "../BadgeDiamond";
import ConfettiRiveAnimation from "../ConfettiRiveAnimation";
import PlayroomBadgeCardDescription from "../PlayroomBadgeCardDescription";
import PlayroomBadgeCardTag from "../PlayroomBadgeCardTag";
import PlayroomBadgeCardCompletedStyled from "./PlayroomBadgeCardCompletedStyled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var PlayroomBadgeCardCompleted = function PlayroomBadgeCardCompleted(_ref) {
  var _ref$coins = _ref.coins,
    coins = _ref$coins === void 0 ? 0 : _ref$coins,
    badgeTitle = _ref.badgeTitle,
    badgeTagLabel = _ref.badgeTagLabel,
    badgeTagColor = _ref.badgeTagColor,
    achievementId = _ref.achievementId,
    subjectName = _ref.subjectName,
    className = _ref.className;
  var hexadecimalColor = useHexCardColor({
    color: badgeTagColor
  });
  return /*#__PURE__*/_jsxs(PlayroomBadgeCardCompletedStyled, {
    hexadecimalColor: hexadecimalColor,
    className: cn(
    // Common styles
    'tw-relative dark:tw-text-primary-light-100 tw-rounded-2.4 tw-overflow-hidden',
    // Shadow
    'hover:tw-shadow-02 hover:dark:tw-shadow-neutral-dark-700 tw-transition-shadow',
    // Borders
    'tw-border tw-border-solid tw-border-neutral-light-400 dark:tw-border-neutral-dark-500',
    // Heights
    'tw-h-24 tw-min-h-24', className),
    children: [coins > 0 && /*#__PURE__*/_jsx(BadgeDiamond, {
      diamonds: coins,
      completed: true,
      className: "tw-z-1"
    }), /*#__PURE__*/_jsx(ConfettiRiveAnimation, {
      achievementId: achievementId,
      badgeTagColor: badgeTagColor,
      className: "tw-z-0"
    }), /*#__PURE__*/_jsx(AchievementLogoRiveAnimation, {
      logoName: badgeTagLabel,
      subjectName: subjectName,
      className: "tw-relative tw-z-1 tw-mt-2 tw-mb-1.2"
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-px-2.4 tw-pb-2.4",
      children: [badgeTagLabel && /*#__PURE__*/_jsx(PlayroomBadgeCardTag, {
        label: badgeTagLabel,
        color: badgeTagColor
      }), /*#__PURE__*/_jsx(PlayroomBadgeCardDescription, {
        text: badgeTitle,
        completed: true
      })]
    })]
  });
};
export default PlayroomBadgeCardCompleted;